import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import utils from "../../utils/utils";
import { dispatch } from "../index";

const navigateTo = "/bodyparts";

const initialState = {
  bodyparts: [],
  bodypartsObject: {},
  error: null,
  totalPages: 1,
  loading: false,
  limit: 10,
  currentPage: 1,
};

// Reducer
const slice = createSlice({
  name: "bodyparts",
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    startLoading(state, action) {
      state.loading = true;
    },
    stopLoading(state, action) {
      state.loading = false;
    },

    getBodypartsSuccess(state, action) {
      const data = action.payload.data;
      state.bodyparts = utils.sortAlphatically(data, "name");
      state.bodypartsObject = utils.getUniqueObject(data, "id");
      const total = action.payload.totalItems;
      let pages = Math.floor(total / state.limit);
      const remainder = total % state.limit;
      if (remainder !== 0) {
        pages += 1;
      }
      state.totalPages = pages;
      state.loading = false;
    },
    addBodypartsSuccess(state, action) {
      state.loading = false;
    },
    editBodypartsSuccess(state, action) {
      state.loading = false;
    },
    deleteBodypartsSuccess(state, action) {
      state.loading = false;
      state.bodyparts = state.bodyparts.filter(
        (item) => item.id !== action.payload.id
      );
    },
    setCurrentPage(state, action) {
      console.log(action.payload);
      state.currentPage = action.payload;
    },
  },
});

export default slice.reducer;

export function startLoading() {
  return async () => {
    dispatch(slice.actions.startLoading());
  };
}

export function stopLoading() {
  return async () => {
    dispatch(slice.actions.stopLoading());
  };
}

export function getBodyparts() {
  return async () => {
    try {
      const result = await axios.get(`/bodyparts?size=1000`);
      console.log("RES [getBodyparts]:", result.data);
      dispatch(slice.actions.getBodypartsSuccess(result.data));
    } catch (error) {
      console.log("ERR [getBodyparts]:", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addBodyparts(data, navigate) {
  return async () => {
    try {
      const result = await axios.post(`/bodyparts`, data);
      console.log("RES [addBodyparts] ======> ", result.data.data);
      dispatch(slice.actions.addBodypartsSuccess(result.data.data));
      navigate(navigateTo);
    } catch (error) {
      console.log("ERR [addBodyparts] =======> ", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function editBodyparts(id, data, navigate) {
  return async () => {
    try {
      const result = await axios.put(`/bodyparts/${id}`, data);
      console.log("RES [editBodyparts] =======> ", result?.data?.data);
      dispatch(slice.actions.editBodypartsSuccess(result?.data?.data));
      navigate(navigateTo);
    } catch (error) {
      console.log("ERR [editBodyparts] ", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteBodyparts(id = "") {
  return async () => {
    try {
      const result = await axios.delete(`/bodyparts/${id}`);
      console.log("RES [deleteEquipment] =======> ", result);
      dispatch(getBodyparts());
      dispatch(slice.actions.deleteBodypartsSuccess(result.data.data));
    } catch (error) {
      dispatch(getBodyparts());
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setCurrentPage(page) {
  return async () => {
    dispatch(slice.actions.setCurrentPage(page));
  };
}
